module.exports = __webpack_public_path__ + "img/home_logo.02ef0110.png";